import React, { memo, useEffect, useMemo, useState } from 'react'
import { Button, ButtonGroup, Col, Form, Modal, /* Modal, */ Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getFarmAddress, getFarmSettings, saveFarmAddress, updateFarmSettings } from '../../actions/farm';
import { Icon } from '../widgets';
import { UsaStates } from 'usa-states';
import ChecklistEditor from './ChecklistEditor';
import { blockInvalidChar, usePermission, validateCollections } from '../../helpers/common';
import { sampleOperatorChecklist, sampleLoadQueueSettings, LoadSamplingSettings, geoCustom, HARVESTING_PLAN_TYPE_ID, PLANTING_PLAN_TYPE_ID, LOGISTIC_PLAN_TYPE_ID } from '../../constants';
import RateScheduleModal from './RateScheduleModal';
import { deleteRateScheduls, getRateScheduleLists, saveRateSchedules } from '../../actions/rate-schedule';
import { getUserId } from '../../helpers/session';
import { DataTableLoading } from '../widgets/DataTable';
import { PopoverSettings } from './PopoverSettings';
import { getLoadParamsByPlanTypeId } from '../../constants/load-headers';

const Farm = () => {
  const usStates = new UsaStates();
  const allow = usePermission();
  const isAllowEdit = allow('farm-settings', 'edit');
  const dispatch = useDispatch();

  const initialState = {
    addressLineOne: "",
    addressLineTwo: "",
    farmCity: "",
    farmState: null,
    zipCode: "",
    phone: "",
    isEdited: false,
    stateOptions: [],
    recentHours: null,
    rateList: null
  };

  const [initialFarmAddress, setInitialFarmAddress] = useState(null);
  const [state, setState] = useState(initialState);
  const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
  const farmName = useSelector(state => state.farm.currentFarm.farm_name);
  const farmAddress = useSelector(state => state.farm.farmAddress);
  const isSaving = useSelector(state => state.farm.isSaving);
  const farmSettings = useSelector(state => state.farm.farmSettings);
  const [hasChecklist, setHasChecklist] = useState(false);
  const [checkList, setChecklist] = useState(null);
  const [settingsJson, setSettingsJson] = useState(null);
  const [jsonError, setJsonError] = useState(false);
  const [hasLoadQueueConfig, setLoadQueueConfig] = useState(false);
  const [loadQueueFields, setloadQueueFieldList] = useState(null);
  const [loadSampling, setloadSampling] = useState(null);
  const [loadGeoParams, setLoadGeoParams] = useState(null);
  const [hasloadSamplingConfig, setLoadSamplingConfig] = useState(false);
  const [hasloadSamplingProfileConfig, setLoadSamplingProfileConfig] = useState(false);
  const [isGeoConfig, setGeoConfig] = useState(false);
  const [isRemoteScale, setRemoteScale] = useState(false);
  const [isLiteEgPermission, setLiteEgPermission] = useState(false);
  const [rateList, setRateList] = useState([]);
  const [isRateSaved, setIsRateSaved] = useState(false)
  const [rateShow, setRateShow] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [isEditRateModal, setEditRateModal] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [isPlanterAllocation, setPlanterAllocation] = useState(false);
  const rateScheduleList = useSelector((state) => state.rateSchedule.rateScheduleList);
  const isRateRequesting = useSelector((state) => state.rateSchedule.isRateRequesting);
  const selectedRateName = deleteItem && deleteItem.rate_name ? deleteItem.rate_name : null;
  const [isStretchTable, setStretchTable] = useState(false);
  const [printHarvestTicket, setHarvestTicket] = useState(false);
  const [printPlantTicket, setPlantTicket] = useState(false);
  const [printLogisticsTicket, setLogisticsTicket] = useState(false);
  const [planParams, setPlanParams] = useState({ harvesting: {}, planting: {}, logistics: {} });
  const [userSelectedColumns, setUserSelected] = useState({ harvesting: { selected_columns: [] }, planting: { selected_columns: [] }, logistics: { selected_columns: [] } });
  const [openPopOver, setOpenPopover] = useState({
    isHarvestingOpen: false,
    isPlantingOpen: false,
    isLogisticsOpen: false
  });
  const [customSettings, setCustomSettings] = useState({});

  useEffect(() => {
    const data = {};

    if (farmSettings && farmSettings.hasOwnProperty('custom_settings')) {
      const custom = farmSettings.custom_settings;
      setCustomSettings(farmSettings.custom_settings);

      if (custom && custom.hasOwnProperty('print_load_ticket')) {
        setUserSelected(custom.print_load_ticket);
      }
    }

    if (farmSettings && farmSettings.hasOwnProperty('checklist')) {
      setChecklist(farmSettings.checklist);
      data['checklist'] = farmSettings.checklist;
    }

    if (farmSettings && farmSettings.hasOwnProperty('has_operator_checklist')) {
      const hasList = farmSettings.has_operator_checklist ? true : false;
      setHasChecklist(hasList);
    }
    if (farmSettings && farmSettings.hasOwnProperty('farm_config')) {
      const load_queue = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('load_queue')) ?
        farmSettings.farm_config.load_queue : {};
      const seed_load_sample = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('seed_load_sample')) ?
        farmSettings.farm_config.seed_load_sample : {};

      const seed_piece_profile_sample = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('seed_piece_profile_sample')) ?
        farmSettings.farm_config.seed_piece_profile_sample : {};

      const load_geo_params = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('load_geo_params')) ? farmSettings.farm_config.load_geo_params : {};
      const scale = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('remote_scale_socket')) ?
        farmSettings.farm_config.remote_scale_socket : {};

      const loadTicket = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('print_load_ticket')) ?
        farmSettings.farm_config.print_load_ticket : {};

      const liteEgPermission = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('lite_eg_permission')) ?
        farmSettings.farm_config.lite_eg_permission : {}
      const rateList = rateScheduleList && rateScheduleList.length > 0 ? rateScheduleList : [];

      const planteAllocation = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('is_planter_allocation')) ?
        farmSettings.farm_config.is_planter_allocation : {};

      const stretchTable = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('stretch_table')) ?
        farmSettings.farm_config.stretch_table : {}

      // const load_queue_recent_hrs = (farmSettings.farm_config && farmSettings.farm_config.hasOwnProperty('load_queue_recent_hours')) ? farmSettings.farm_config.load_queue_recent_hours : {};

      const visible = (load_queue && load_queue.visible) ? load_queue.visible : false;
      const visibleSample = (seed_load_sample && seed_load_sample.visible) ? seed_load_sample.visible : false;
      const seedProfileVisible = (seed_piece_profile_sample && seed_piece_profile_sample.visible ? seed_piece_profile_sample.visible : false)
      const visibleGeoConfig = (load_geo_params.visible ? load_geo_params.visible : false);
      const remoteScaleEnable = (scale && scale.visible) ? scale.visible : false;
      const liteEgPermissionVisible = (liteEgPermission && liteEgPermission.visible) ? liteEgPermission.visible : false;
      const sortedRateList = validateCollections(rateList) ? rateList.sort((prev, next) => prev.rate_name.localeCompare(next.rate_name)) : [];
      const stretchTableVisible = stretchTable && stretchTable.visible ? stretchTable.visible : false;
      const pAVisible = (planteAllocation && planteAllocation.visible) ? planteAllocation.visible : false;

      const harvestTicketVisible = (loadTicket && loadTicket.harvesting_visible) ? loadTicket.harvesting_visible : false;
      const plantTicketVisible = (loadTicket && loadTicket.planting_visible) ? loadTicket.planting_visible : false;
      const logisticsTicketVisible = (loadTicket && loadTicket.logistics_visible) ? loadTicket.logistics_visible : false;

      setLoadQueueConfig(visible);
      setLoadSamplingConfig(visibleSample);
      setLoadSamplingProfileConfig(seedProfileVisible)
      setGeoConfig(visibleGeoConfig);
      setRemoteScale(remoteScaleEnable);
      setLiteEgPermission(liteEgPermissionVisible);
      setRateList(sortedRateList);
      setStretchTable(stretchTableVisible)
      setPlanterAllocation(pAVisible);

      setHarvestTicket(harvestTicketVisible);
      setPlantTicket(plantTicketVisible);
      setLogisticsTicket(logisticsTicketVisible);

      if (load_queue && load_queue.configuration && load_queue.configuration.load_queue_params) {
        setloadQueueFieldList(load_queue.configuration);
        data['loadQueueFieldList'] = load_queue.configuration;
      } else {
        setloadQueueFieldList(sampleLoadQueueSettings);
        data['loadQueueFieldList'] = sampleLoadQueueSettings;
      }

      if (seed_load_sample && seed_load_sample.configuration && seed_load_sample.configuration.seed_load_sample_params) {
        setloadSampling(seed_load_sample.configuration);
        data['loadSampling'] = seed_load_sample.configuration;
      } else {
        setloadSampling(LoadSamplingSettings);
        data['loadSampling'] = LoadSamplingSettings;
      }

      if (load_geo_params && load_geo_params.configuration && load_geo_params.configuration.geo_custom_params) {
        setLoadGeoParams(load_geo_params.configuration);
        data['loadGeoCustom'] = load_geo_params.configuration;
      } else {
        setLoadGeoParams(geoCustom);
        data['loadGeoCustom'] = loadGeoParams;
      }
    }
    setSettingsJson(data);
  }, [farmSettings]);

  useEffect(() => {
    if (rateScheduleList && rateScheduleList.length > 0) {
      setRateList(rateScheduleList)
    }
  }, [rateScheduleList])

  const SettingsHeader = ({ children }) => {
    return (<Row className="header">
      <h6>{children}</h6>
    </Row>);
  };

  const SettingsButtonGroup = ({ title, name, activeKey, children, onSelect, disabled }) => {
    const childrens = React.Children.map(children, (child) => {
      if (child.props.hasOwnProperty("eventkey")) {
        return React.cloneElement(child, {
          variant: (parseInt(activeKey) === parseInt(child.props.eventkey)) ? 'primary' : 'default',
          onClick: () => onSelect(child.props.eventkey, name),
          disabled
        });
      }
      return child;
    });

    return (<Row className="pb-3">
      <Col className="label" lg={3} md={3} sm={3}>{title}</Col>
      <Col lg={9} md={9} sm={9}>
        <ButtonGroup size="sm" toggle={true}>
          {childrens}
        </ButtonGroup>
      </Col>
    </Row>);
  };

  useEffect(() => {
    dispatch(getFarmAddress(farmId));
    dispatch(getFarmSettings({ farm_uuid: farmId }));
    dispatch(getRateScheduleLists(farmId))
  }, [farmId]);

  useEffect(() => {
    const usStateOption = usStates.states.map((state) => {
      return ({ value: state.abbreviation, label: state.name })
    })

    let recentHours;
    const farmConfig = farmSettings && farmSettings.farm_config;
    if (farmConfig) {
      const loadQueueRecentHrs = farmConfig && farmConfig.load_queue_recent_hours;
      recentHours = loadQueueRecentHrs && loadQueueRecentHrs.recent_hours ?
        loadQueueRecentHrs && loadQueueRecentHrs.recent_hours : 0;
    }

    const data = {
      addressLineOne: farmAddress && farmAddress.address ? farmAddress.address.addressLineOne : "",
      addressLineTwo: farmAddress && farmAddress.address ? farmAddress.address.addressLineTwo : "",
      farmCity: farmAddress && farmAddress.address ? farmAddress.address.city : "",
      farmState: farmAddress && farmAddress.address ? farmAddress.address.state : null,
      zipCode: farmAddress && farmAddress.address ? farmAddress.address.zipCode : "",
      phone: farmAddress && farmAddress.phone ? farmAddress.phone : "",
      stateOptions: usStateOption,
      recentHours: recentHours
    }
    setState({
      ...state,
      ...data
    });
    setInitialFarmAddress({
      ...data,
      isEdited: false
    });
  }, [farmAddress, farmSettings, farmId]);

  const handleChange = (name, value) => {
    setState({ ...state, [name]: value, isEdited: true });
  };

  const handleSelect = (item, event) => {
    const { name } = event;
    setState({ ...state, [name]: item ? item.value : null, isEdited: true });
  };

  const handleSave = () => {
    const params = {
      farm_uuid: farmId,
      address: {
        addressLineOne: state.addressLineOne,
        addressLineTwo: state.addressLineTwo,
        city: state.farmCity,
        state: state.farmState,
        zipCode: state.zipCode,
      },
      phone: [state.phone]
    };

    const { loadQueueFieldList, checklist, loadSampling, loadGeoCustom } = settingsJson;
    const settingsParams = {
      farm_uuid: farmId,
      user_id: getUserId(),
      has_operator_checklist: hasChecklist,
      checklist,
      farm_config: {
        load_queue: {
          visible: hasLoadQueueConfig,
          configuration: (loadQueueFieldList && loadQueueFieldList.load_queue_params) ?
            {
              ...loadQueueFieldList,
              load_queue_params: loadQueueFieldList.load_queue_params.sort((a, b) => a.display_order - b.display_order)
            } : {}
        },
        seed_load_sample: {
          visible: hasloadSamplingConfig,
          allowMultiple: (loadSampling && loadSampling.allowMultiple) ? loadSampling.allowMultiple : false,
          plan_type_ids: (loadSampling && loadSampling.plan_type_ids) ? loadSampling.plan_type_ids : '1',
          configuration: (loadSampling && loadSampling.seed_load_sample_params) ?
            {
              ...loadSampling,
              seed_load_sample_params: loadSampling.seed_load_sample_params.sort((a, b) => a.display_order - b.display_order)
            } : {}
        },
        seed_piece_profile_sample: {
          visible: hasloadSamplingProfileConfig
        },
        load_geo_params: {
          visible: isGeoConfig,
          configuration: loadGeoCustom && loadGeoCustom.geo_custom_params ? { ...loadGeoCustom } : {}
        },
        remote_scale_socket: {
          visible: isRemoteScale
        },
        print_load_ticket: {
          harvesting_visible: printHarvestTicket,
          planting_visible: printPlantTicket,
          logistics_visible: printLogisticsTicket
        },
        load_queue_recent_hours: {
          // visible: isLoadQueueRecentHrs,
          recent_hours: state.recentHours ? Number(state.recentHours) : null
        },
        lite_eg_permission: {
          visible: isLiteEgPermission,
          create: isLiteEgPermission
        },
        stretch_table: {
          visible: isStretchTable
        },
        is_planter_allocation: {
          visible: isPlanterAllocation
        }
      },
      custom_settings: {
        ...customSettings,
        print_load_ticket: userSelectedColumns
      }
    }

    if ((rateScheduleList && rateScheduleList.length > 0) && (rateList && rateList.length > 0)) {
      let changedItems = rateList.map((rate) => {
        return {
          ...rate,
          rate_schedule_applicable: rate.rate_schedule_applicable ? 1 : 0,
        }
      }).filter(current => {
        const previous = rateScheduleList.find(prev => prev.rate_uuid === current.rate_uuid);
        return previous && previous.rate_schedule_applicable !== current.rate_schedule_applicable;
      });

      changedItems = changedItems.map(changedItem => {
        return {
          rate_uuid: changedItem.rate_uuid,
          rate_name: changedItem.rate_name,
          rate_type_uuid: changedItem.rate_type_uuid,
          rate_value: changedItem.rate_value,
          rate_schedule_applicable: changedItem.rate_schedule_applicable,
          surcharge_applicable: changedItem.surcharge_applicable,
          surcharge_type_uuid: changedItem.surcharge_type_uuid,
          surcharge_value: changedItem.surcharge_value
        }
      })

      const rateParams = {
        farm_uuid: farmId,
        user_id: getUserId(),
        rate_schedule: changedItems
      }
      dispatch(saveRateSchedules(rateParams))
    }

    const cb = () => {
      setState({ ...state, isEdited: false });
      dispatch(getFarmAddress(farmId));
    }
    dispatch(saveFarmAddress(params, cb));

    dispatch(updateFarmSettings(settingsParams, () => {
      dispatch(getFarmSettings({ farm_uuid: farmId }));
      dispatch(getRateScheduleLists(farmId))
    }));
    setState({ ...state, isEdited: false });
    setIsRateSaved(false);
  };

  const handleCancel = () => {
    setState(initialFarmAddress);
    setRateList(rateScheduleList)
  };

  const { addressLineOne, addressLineTwo, farmCity, farmState, zipCode, phone, isEdited, stateOptions, recentHours } = state;

  const updateCheckList = (keyName, checkListJSON) => {
    const params = {};
    params[keyName] = checkListJSON;
    setSettingsJson({ ...settingsJson, ...params });
    setState({ ...state, isEdited: true });
  }

  const toggleVisibility = (id) => {
    setRateList((prevList) =>
      prevList.map((item) =>
        item.rate_uuid === id ? { ...item, rate_schedule_applicable: !item.rate_schedule_applicable } : item
      )
    );
    setState({ ...state, isEdited: true });
  };

  useEffect(() => {
    if (isRateSaved) {
      handleSave()
      setIsRateSaved(false);
    }
  }, [isRateSaved])

  const confirmDeleteRate = () => {
    const cb = (isSaved) => {
      if (isSaved) setRateList((prevList) => prevList.filter((item) => item.rate_uuid !== deleteItem.rate_uuid));
    };

    let deletedId = deleteItem && deleteItem.rate_uuid ? deleteItem.rate_uuid : '';
    deletedId = {
      rate_uuid: deletedId
    }

    const params = {
      farm_uuid: farmId,
      user_id: getUserId(),
      rate_schedule: [deletedId]
    }
    dispatch(deleteRateScheduls(params, cb));
  }

  const enableConfirmModal = (it) => {
    setDeleteModal(true);
    setDeleteItem(it)
  }

  const enableEditRateModal = (it) => {
    setEditRateModal(true);
    setRateShow(true);
    setEditedData(it);
  }
  const handleClose = () => {
    setRateShow(false);
    setEditRateModal(false);
  };
  const handleShow = () => setRateShow(true);

  useEffect(() => {
    const harvestParams = getLoadParamsByPlanTypeId(HARVESTING_PLAN_TYPE_ID, farmSettings.farm_config);
    const plantingParams = getLoadParamsByPlanTypeId(PLANTING_PLAN_TYPE_ID, farmSettings.farm_config);
    const logisticsParams = getLoadParamsByPlanTypeId(LOGISTIC_PLAN_TYPE_ID, farmSettings.farm_config);
    setPlanParams({ harvesting: harvestParams, planting: plantingParams, logistics: logisticsParams });
  }, [farmSettings]);

  const { harvestkeys, harvestAllColumns, plantingKeys, plantingAllColumns, logisticsKeys, logisticsAllColumns } = useMemo(() => {
    const harvestParams = planParams['harvesting'];
    const plantingParams = planParams['planting'];
    const logisticsParams = planParams['logistics'];
    return {
      harvestkeys: harvestParams.allKeys || [],
      harvestAllColumns: harvestParams.allColumns || [],
      plantingKeys: plantingParams.allKeys || [],
      plantingAllColumns: plantingParams.allColumns || [],
      logisticsKeys: logisticsParams.allKeys || [],
      logisticsAllColumns: logisticsParams.allColumns || []
    }
  }, [planParams]);

  const onColumnSelectedApply = (selectedColumns, key) => {
    const updatedData = {
      ...userSelectedColumns[key],
      selected_columns: selectedColumns
    }
    setUserSelected({ ...userSelectedColumns, [key]: updatedData });
    setState({ ...state, isEdited: true });
  };

  const setPopover = (isOpen, key) => {
    setOpenPopover({
      isHarvestingOpen: false,
      isPlantingOpen: false,
      isLogisticsOpen: false,
      [key]: isOpen
    });
  }

  return (
    <div className='settings animate animate__slideInUp'>
      <SettingsHeader>Farm Address</SettingsHeader>
      <>
        <div className='farm-detail-bg'>
          <div className='farm-detail'>
            <div className='farm-title'>{farmName}</div>
            {addressLineOne && <div className='other'>{`${addressLineOne}, `}</div>}
            {addressLineTwo && <div className='other'>{`${addressLineTwo}, `}</div>}
            <div className='other'>{`${farmCity ? `${farmCity}, ` : ""} ${farmState ? `${farmState}, ` : ""} ${zipCode ? `${zipCode}, ` : ""}`}</div>
            {phone && <div className='other'>{`${phone}.`}</div>}
          </div>
        </div>
        <Form className="farm-settings">
          <Form.Group>
            <Form.Label htmlFor="name" className="settings-label">Name</Form.Label>
            <Form.Control id="name" type="text" autoComplete="off" className='settings-input'
              value={farmName} name="name" disabled={true} />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="address1" className="settings-label">Address line 1</Form.Label>
            <Form.Control id="address1" type="text" autoComplete="off" className='settings-input'
              value={addressLineOne} name="addressLineOne" onChange={(e) => handleChange(e.target.name, e.target.value)} disabled={!isAllowEdit} />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="address2" className="settings-label">Address line 2</Form.Label>
            <Form.Control id="address2" type="text" autoComplete="off" className='settings-input'
              value={addressLineTwo} name="addressLineTwo" onChange={(e) => handleChange(e.target.name, e.target.value)} disabled={!isAllowEdit} />
          </Form.Group>
          <div className="city-state">
            <Form.Group>
              <Form.Label htmlFor="farmState" className="settings-label">State</Form.Label>
              <Form.Select id="farmState" className='settings-input select-control' placeholder="Select State"
                value={farmState} options={stateOptions} name="farmState" onChange={handleSelect} disabled={!isAllowEdit} />
            </Form.Group>
            <Form.Group>
              <Form.Label htmlFor="farmCity" className="settings-label">City</Form.Label>
              <Form.Control id="farmCity" type="text" autoComplete="off" className='settings-input'
                value={farmCity} name="farmCity" onChange={(e) => handleChange(e.target.name, e.target.value)} disabled={!isAllowEdit} />
            </Form.Group>
          </div>
          <div className="country-phone">
            <Form.Group>
              <Form.Label htmlFor="zipCode" className="settings-label">Zip code</Form.Label>
              <Form.Control id="zipCode" type="number" autoComplete="off" className='settings-input'
                value={zipCode} name="zipCode" onChange={(e) => handleChange(e.target.name, e.target.value)} disabled={!isAllowEdit} />
            </Form.Group>
            <Form.Group>
              <Form.Label htmlFor="phone" className="settings-label">Phone</Form.Label>
              <Form.Control id="phone" type="text" autoComplete="off" className='settings-input'
                value={phone} name="phone" onChange={(e) => handleChange(e.target.name, e.target.value)} disabled={!isAllowEdit} />
            </Form.Group>
          </div>
        </Form>
      </>

      <SettingsHeader>Custom Messages</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="hasOperatorChecklist"
          title="Operator Message Checklist"
        >
          <Form.Check
            type="switch"
            id='hasOperatorChecklist'
            name="hasOperatorChecklist"
            title="Operator Message Checklist"
            checked={hasChecklist}
            onChange={(e) => {
              setHasChecklist(e.target.checked);
              setState({ ...state, isEdited: true });
              //if (!e.target.checked) updateCheckList(checkList, e.target.checked);
            }}
          />

        </SettingsButtonGroup>
        {hasChecklist && <ChecklistEditor setJsonError={setJsonError} keyName='checklist' sampleData={sampleOperatorChecklist} data={checkList} farmId={farmId} updateCheckList={updateCheckList} />}
      </div>

      <SettingsHeader>Load Params</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="showLoadQueueConfig"
          title="Load Queue Params"
        >
          <Form.Check
            type="switch"
            id='showLoadQueueConfig'
            name="showLoadQueueConfig"
            title="Load Queue Params"
            checked={hasLoadQueueConfig}
            onChange={(e) => {
              setLoadQueueConfig(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup>
        {hasLoadQueueConfig && <ChecklistEditor setJsonError={setJsonError} keyName='loadQueueFieldList' sampleData={sampleLoadQueueSettings} data={loadQueueFields} farmId={farmId} updateCheckList={updateCheckList} />}
      </div>

      <SettingsHeader>Load Sample</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="showLoadSamplingConfig"
          title="Load Sampling Params"
        >
          <Form.Check
            type="switch"
            id='showLoadSamplingConfig'
            name="showLoadSamplingConfig"
            title="Load Sampling Params"
            checked={hasloadSamplingConfig}
            onChange={(e) => {
              setLoadSamplingConfig(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup>
        {hasloadSamplingConfig && <ChecklistEditor setJsonError={setJsonError} keyName='loadSampling' sampleData={LoadSamplingSettings} data={loadSampling} farmId={farmId} updateCheckList={updateCheckList} />}
      </div>

      <SettingsHeader>Load Sample - Customized</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="showLoadSamplingProfileConfig"
          title="Milestone Seed Piece Profile Table"
        >
          <Form.Check
            type="switch"
            id='showLoadSamplingProfileConfig'
            name="showLoadSamplingProfileConfig"
            title="Milestone Seed Piece Profile Table"
            checked={hasloadSamplingProfileConfig}
            onChange={(e) => {
              setLoadSamplingProfileConfig(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup>
      </div>
      <SettingsHeader>Geo Regions - Custom</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="showFieldShapeConfig"
          title="Geo Regions - Custom"
        >
          <Form.Check
            type="switch"
            id="showFieldShapeConfig"
            name="showFieldShapeConfig"
            title="Geo Regions - Custom"
            checked={isGeoConfig}
            onChange={(e) => {
              setGeoConfig(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup >
        {
          isGeoConfig ?
            <ChecklistEditor setJsonError={setJsonError}
              keyName="loadGeoCustom"
              sampleData={geoCustom}
              data={loadGeoParams}
              farmId={farmId}
              updateCheckList={updateCheckList}
            /> : null}
      </div >
      <SettingsHeader>Scale Remote</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="remotescale"
          title="Scale Remote"
        >
          <Form.Check
            type="switch"
            id='remotescale'
            name="remotescale"
            title="Scale Remote"
            checked={isRemoteScale}
            onChange={(e) => {
              setRemoteScale(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup>
      </div>
      <div className='ticket-list__hldr'>
        <SettingsHeader>Load Queue Ticket Print</SettingsHeader>
        <div className='px-3'>
          <SettingsButtonGroup
            name="harvestingloadticketprint"
            title="Harvesting"
          >
            <Form.Check
              type="switch"
              id='harvestingloadticketprint'
              name="harvestingloadticketprint"
              title="Harvesting"
              checked={printHarvestTicket}
              onChange={(e) => {
                setHarvestTicket(e.target.checked);
                setState({ ...state, isEdited: true });
              }}
            />
            <PopoverSettings
              intialColumnsList={harvestAllColumns}
              showableCustomColumns={harvestkeys}
              userPreferredColumn={userSelectedColumns['harvesting']['selected_columns']}
              onColumnSelectedApply={(selectedColumns) => onColumnSelectedApply(selectedColumns, 'harvesting')}
              isDisabled={!printHarvestTicket}
              isOpen={openPopOver['isHarvestingOpen']}
              setIsOpen={(isOpen) => setPopover(isOpen, 'isHarvestingOpen')}
            />
          </SettingsButtonGroup>
          <SettingsButtonGroup
            name="plantingloadticketprint"
            title="Planting"
          >
            <Form.Check
              type="switch"
              id='plantingloadticketprint'
              name="plantingloadticketprint"
              title="Planting"
              checked={printPlantTicket}
              onChange={(e) => {
                setPlantTicket(e.target.checked);
                setState({ ...state, isEdited: true });
              }}
            />
            <PopoverSettings
              intialColumnsList={plantingAllColumns}
              showableCustomColumns={plantingKeys}
              userPreferredColumn={userSelectedColumns['planting']['selected_columns']}
              onColumnSelectedApply={(selectedColumns) => onColumnSelectedApply(selectedColumns, 'planting')}
              isDisabled={!printPlantTicket}
              isOpen={openPopOver['isPlantingOpen']}
              setIsOpen={(isOpen) => setPopover(isOpen, 'isPlantingOpen')}
            />
          </SettingsButtonGroup>
          <SettingsButtonGroup
            name="logisticsloadticketprint"
            title="Logistics"
          >
            <Form.Check
              type="switch"
              id='logisticsloadticketprint'
              name="logisticsloadticketprint"
              title="Logistics"
              checked={printLogisticsTicket}
              onChange={(e) => {
                setLogisticsTicket(e.target.checked);
                setState({ ...state, isEdited: true });
              }}
            />
            <PopoverSettings
              intialColumnsList={logisticsAllColumns}
              showableCustomColumns={logisticsKeys}
              userPreferredColumn={userSelectedColumns['logistics']['selected_columns']}
              onColumnSelectedApply={(selectedColumns) => onColumnSelectedApply(selectedColumns, 'logistics')}
              isDisabled={!printLogisticsTicket}
              isOpen={openPopOver['isLogisticsOpen']}
              setIsOpen={(isOpen) => setPopover(isOpen, 'isLogisticsOpen')}
            />
          </SettingsButtonGroup>
        </div>
      </div>
      <SettingsHeader>Load Queue Recent Hours</SettingsHeader>
      <div className='px-3'>
        <Form.Group>
          <Form.Label htmlFor="hours" className="settings-label__hrs">Load Queue Recent Hours</Form.Label>
          <Form.Control id="hours"
            type="number"
            name="recentHours"
            autoComplete="off"
            className='settings-input w-25'
            onKeyDown={blockInvalidChar}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={recentHours || ""}
            min={0}
          />
        </Form.Group>
      </div>
      <SettingsHeader>Lite Role</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="liteRole"
          title="Equipment Group Create"
        >
          <Form.Check
            type="switch"
            id='liteEgPermission'
            name="liteEgPermission"
            title="Permission for Equipment Group Create"
            checked={isLiteEgPermission}
            onChange={(e) => {
              setLiteEgPermission(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup>
      </div>
      <SettingsHeader>Stretch Table</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup
          name="showStretchTableConfig"
          title="Stretch Table"
        >
          <Form.Check
            type="switch"
            id='showStretchTableConfig'
            name="showStretchTableConfig"
            title="Stretch Table"
            checked={isStretchTable}
            onChange={(e) => {
              setStretchTable(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />

        </SettingsButtonGroup>
      </div>

      <SettingsHeader>Planter Allocation</SettingsHeader>
      <div className='px-3'>
        <SettingsButtonGroup name="planterAllocation" title="Planter Allocation">
          <Form.Check
            type="switch"
            id='planterAllocation'
            name="planterAllocation"
            title="Planter Allocation"
            checked={isPlanterAllocation}
            onChange={(e) => {
              setPlanterAllocation(e.target.checked);
              setState({ ...state, isEdited: true });
            }}
          />
        </SettingsButtonGroup>
      </div>
      <SettingsHeader>Rate Schedules
        <Button className='mx-4' size="sm" variant={`success`} onClick={() => handleShow()}>
          <Icon className={`fa fa-plus-circle`} /> Create
        </Button>
      </SettingsHeader>

      <div>
        <div className='rate-list__hldr'>
          {isRateRequesting ? <DataTableLoading /> : validateCollections(rateList) && rateList.map((it, index) =>
            <div key={`rate-${index}`} className='px-3 mt-3'>
              <SettingsButtonGroup
                name={it.rate_name}
                title={it.rate_name}
              >
                <Form.Check
                  type="switch"
                  id={`${it.rate_uuid}`}
                  name={it.rate_name}
                  title={it.rate_name}
                  checked={it.rate_schedule_applicable}
                  onChange={() => toggleVisibility(it.rate_uuid)}
                />
                <Icon
                  className='fa fa-pencil mx-1 cursor-pointer'
                  title='Edit'
                  onClick={() => enableEditRateModal(it)}
                />
                <Icon
                  className='fa fa-trash mx-1 cursor-pointer'
                  title='Delete'
                  onClick={() => enableConfirmModal(it)}
                />
              </SettingsButtonGroup>
            </div>
          )}
        </div>
        {rateShow || isEditRateModal ? <RateScheduleModal
          show={rateShow}
          handleClose={handleClose}
          farmId={farmId}
          rateList={rateList}
          setRateList={setRateList}
          handleSave={handleSave}
          isEditRateModal={isEditRateModal}
          setEditRateModal={setEditRateModal}
          editedData={editedData}
          setIsRateSaved={setIsRateSaved} /> : null}
      </div>
      {showDeleteModal ?
        <Modal.Confirm
          isOpen={showDeleteModal}
          onConfirm={confirmDeleteRate}
          iconClassName='fa fa-trash'
          className="modal_delete_hover"
          body={<div className='col'>Do you want to delete  <b className='text-danger'>{selectedRateName}</b> including its selection on the crews?</div>}
          confirmButton={{
            content: "Delete",
            className: "btn-danger",
          }}
          cancelButton={{
            content: "Cancel",
            className: "btn-cancel",
            autoFocus: true,
          }}
          onHide={() => setDeleteModal(false)}
        /> : null}

      <div className='px-3'>
        {isEdited && !jsonError && <div className='settings-button'>
          <Button variant='danger' className='button' size="sm" onClick={handleCancel}><Icon className="fa fa-times pr-1" />Cancel</Button>
          <Button variant='primary' className='button' size="sm" onClick={handleSave}><Icon className="fa fa-floppy-o pr-1" /> {isSaving ? 'Saving...' : 'Save'}</Button>
        </div>}
      </div>
    </div >
  )
}

export default memo(Farm);
